module.exports = __webpack_public_path__ + "img/locator-sentosa-orange.9a8cff4f.svg";